import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { IntlMsgShape } from 'helpers/consts';

import bannerVariables from 'styles/base/bannerVariables.module.scss';

type SelectorState = { banner: BannerState };

export type BannerState = {
  showBanner: boolean | undefined;
  banner: BannerShape;
};
export interface BannerShape {
  message: IntlMsgShape;
  displaySeconds: number;
}
export const initialBannerState: BannerState = {
  showBanner: undefined,
  banner: { message: { id: '' }, displaySeconds: 0 },
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState: initialBannerState,
  reducers: {
    setBannerData: (state, action: PayloadAction<BannerShape>) => {
      state.showBanner = true;
      state.banner.message = action.payload.message;
      state.banner.displaySeconds = action.payload.displaySeconds;
    },
    hideBanner: (state) => {
      state.showBanner = false;
      state.banner.message = { id: '' };
      state.banner.displaySeconds = 0;
    },
    resetBanner: (state) => {
      state.showBanner = undefined;
      state.banner.message = { id: '' };
      state.banner.displaySeconds = 0;
    },
  },
});

export const bannerVisible = (state: SelectorState) => state.banner.showBanner;

export const displaySeconds = (state: SelectorState) =>
  state.banner.banner.displaySeconds;

export const bannerMessage = (state: SelectorState) => {
  return state.banner.banner.message;
};

export const showBanner = createAsyncThunk<void, BannerShape>(
  'banner/showBanner',
  async (banner, { dispatch }) => {
    dispatch(setBannerData(banner));
    setTimeout(() => {
      dispatch(hideBanner());
      setTimeout(() => {
        dispatch(resetBanner());
      }, bannerVariables.bannerAnimationDuration);
    }, banner.displaySeconds * 1000);
  },
);

export const { setBannerData, hideBanner, resetBanner } = bannerSlice.actions;

export default bannerSlice.reducer;
